module.exports = __webpack_public_path__ + "static/media/guests.51b2139b.jpg";